(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gold-studs-offer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function init() {
      document.querySelectorAll('[data-studs-offer]').forEach((root) => {
        if (root.dataset.ready) return;
        root.dataset.ready = 'true';

        root.querySelector('[data-copy]')?.addEventListener('click', async () => {
          const code = root.querySelector('[data-code]').textContent.trim();
          try {
            await navigator.clipboard.writeText(code);
            root.querySelector('[data-copy-status]').textContent = 'Code copied.';
          } catch {
            root.querySelector('[data-copy-status]').textContent = `Your code: ${code}`;
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sinclairs-diamond-education"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(scope) {
    scope.querySelectorAll('[data-sc-education]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const list = root.querySelector('[data-sc-tabs]');
      const tabs = [...list.querySelectorAll('[role="tab"]')];
      const panels = [...root.querySelectorAll('[data-sc-panel]')];
      function select(index, focus) {
        tabs.forEach((tab, i) => {
          tab.setAttribute('aria-selected', String(i === index));
          tab.tabIndex = i === index ? 0 : -1;
          panels[i].hidden = i !== index;
          panels[i].setAttribute('role', 'tabpanel');
          panels[i].tabIndex = 0;
        });
        if (focus) tabs[index].focus();
      }
      list.hidden = false;
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(i, false));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (i + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(next, true); }
        });
      });
      select(0, false);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', () => init(document));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sinclairs-offer-popup"]) return;
  try {
    
(() => {
  if (customElements.get('sinclairs-offer-popup')) return;
  class SinclairsOfferPopup extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const options = { signal:this.controller.signal };
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('click', event => {
        const r = this.dialog.getBoundingClientRect();
        if (event.target === this.dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) this.dialog.close();
      }, options);
      this.dialog.addEventListener('close', () => {
        if (this.previousOverflow !== undefined) {
          document.documentElement.style.overflow = this.previousOverflow;
          this.previousOverflow = undefined;
        }
        if (this.returnFocus?.isConnected) this.returnFocus.focus({preventScroll:true});
      }, options);
      this.querySelectorAll('[data-copy-code]').forEach(button => button.addEventListener('click', async () => {
        const code = button.dataset.copyCode;
        const feedback = this.querySelector('[data-feedback]');
        try { await navigator.clipboard.writeText(code); feedback.textContent = 'Offer code copied.'; }
        catch { feedback.textContent = `Your offer code: ${code}`; }
      }, options));
      this.querySelectorAll('.nop-shop').forEach(link => link.addEventListener('click', () => this.dialog.close(), options));
      this.key = `sinclairs:offers:${this.dataset.campaign || 'launch-v1'}`;
      if (this.hasAttribute('data-editor')) {
        document.addEventListener('shopify:section:select', event => {
          if (event.target === this || event.target.contains?.(this)) this.show(true);
        }, options);
        document.addEventListener('shopify:section:deselect', event => {
          if (event.target === this || event.target.contains?.(this)) this.dialog.close();
        }, options);
        return;
      }
      if (this.dataset.enabled !== 'true' || !this.querySelector('.nop-offer') || this.dataset.page === 'cart' || this.dataset.page === 'password') return;
      if (this.dataset.homeOnly === 'true' && this.dataset.page !== 'index') return;
      if (this.seen()) return;
      this.timer = setTimeout(() => {
        this.readyToShow = true;
        this.show();
      }, Math.max(0, Number(this.dataset.delay) || 0) * 1000);
      document.addEventListener('visibilitychange', () => { if (this.readyToShow) this.show(); }, options);
      document.addEventListener('close', () => { if (this.readyToShow) this.show(); }, { ...options, capture:true });
    }
    seen() {
      try {
        if (this.dataset.frequency === 'page') return false;
        if (this.dataset.frequency === 'day') {
          const saved = Number(localStorage.getItem(this.key));
          return saved > 0 && Date.now() - saved < 86400000;
        }
        return sessionStorage.getItem(this.key) === 'shown';
      } catch { return false; }
    }
    show(editor = false) {
      if (!this.isConnected || this.dialog.open || document.hidden || (!editor && (this.shown || this.seen()))) return;
      if (document.querySelector('dialog[open]')) return;
      // Reuse the configured gift image if the merchant did not select an image.
      const media = this.querySelector('[data-popup-media]');
      if (!media.querySelector('img')) {
        try {
          const source = document.querySelector('gift-offer-controller [data-gift-presentation]');
          const gift = source && JSON.parse(source.textContent);
          if (gift?.image) {
            const image = document.createElement('img'); image.src = gift.image;
            image.alt = gift.productTitle || 'Complimentary gift'; image.decoding = 'async';
            media.append(image); media.hidden = false;
          }
        } catch { /* Image is optional. */ }
      }
      this.returnFocus = document.activeElement;
      this.dialog.showModal();
      this.previousOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      this.shown = true;
      this.readyToShow = false;
      if (!editor) {
        try {
          if (this.dataset.frequency === 'day') localStorage.setItem(this.key, String(Date.now()));
          else if (this.dataset.frequency !== 'page') sessionStorage.setItem(this.key, 'shown');
        } catch { /* Still show once on this page if storage is blocked. */ }
      }
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      if (this.dialog?.open) this.dialog.close();
      if (this.previousOverflow !== undefined) document.documentElement.style.overflow = this.previousOverflow;
      this.controller?.abort();
    }
  }
  customElements.define('sinclairs-offer-popup', SinclairsOfferPopup);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sinclairs-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('sinclairs-reviews')) return;
  class SinclairsReviews extends HTMLElement {
    connectedCallback() {
      if (this.lightbox?.open) this.lightbox.close();
      this.controller?.abort();
      this.controller = new AbortController();
      const options = {signal:this.controller.signal};
      this.lightbox = this.querySelector('[data-review-lightbox]');
      if (this.lightbox && typeof this.lightbox.showModal === 'function') {
        const image = this.lightbox.querySelector('[data-photo-full]');
        const caption = this.lightbox.querySelector('[data-photo-caption]');
        this.querySelectorAll('[data-review-photo]').forEach(link => {
          link.addEventListener('click', event => {
            // Keep modified clicks available for opening the image in another tab.
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
            event.preventDefault();
            image.width = Number(link.dataset.photoWidth) || 1;
            image.height = Number(link.dataset.photoHeight) || 1;
            image.src = link.href;
            image.alt = link.querySelector('img')?.alt || 'Customer review photograph';
            caption.textContent = link.dataset.photoCaption ? `Photo shared by ${link.dataset.photoCaption}` : '';
            this.photoReturnFocus = link;
            if (!this.lightbox.open) {
              this.lightbox.showModal();
              this.photoPreviousOverflow = document.documentElement.style.overflow;
              document.documentElement.style.overflow = 'hidden';
            }
          }, options);
        });
        this.lightbox.querySelector('[data-photo-close]').addEventListener('click', () => this.lightbox.close(), options);
        this.lightbox.addEventListener('click', event => {
          const r = this.lightbox.getBoundingClientRect();
          if (event.target === this.lightbox && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) this.lightbox.close();
        }, options);
        this.lightbox.addEventListener('close', () => {
          this.restorePhotoScroll();
          if (this.photoReturnFocus?.isConnected) this.photoReturnFocus.focus({preventScroll:true});
          image.removeAttribute('src');
          caption.textContent = '';
        }, options);
      }
      const cards = [...this.querySelectorAll('[data-review-source]')];
      cards.forEach(card => { card.hidden = false; });
      const sources = new Set(cards.map(card => card.dataset.reviewSource));
      const filters = this.querySelector('.sr-filters');
      if (filters) {
        filters.hidden = sources.size < 2;
        filters.querySelectorAll('[data-filter]').forEach(button => {
          const source = button.dataset.filter;
          button.setAttribute('aria-pressed', String(source === 'all'));
          button.hidden = source !== 'all' && !sources.has(source);
          button.addEventListener('click', () => {
            filters.querySelectorAll('[data-filter]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            let shown = 0;
            cards.forEach(card => { card.hidden = source !== 'all' && card.dataset.reviewSource !== source; if (!card.hidden) shown++; });
            this.querySelector('[data-filter-status]').textContent = `${shown} ${shown === 1 ? 'review' : 'reviews'} shown`;
          }, options);
        });
      }
      cards.forEach(card => {
        const quote = card.querySelector('.sr-quote');
        const button = card.querySelector('.sr-expand');
        // Short reviews remain unclipped; long reviews can be expanded without navigation.
        if (quote.textContent.trim().length < 240) return;
        quote.setAttribute('data-collapsed', ''); button.hidden = false;
        button.setAttribute('aria-expanded', 'false'); button.textContent = 'Read more';
        button.addEventListener('click', () => {
          const expanded = button.getAttribute('aria-expanded') !== 'true';
          button.setAttribute('aria-expanded', String(expanded));
          quote.toggleAttribute('data-collapsed', !expanded);
          button.textContent = expanded ? 'Read less' : 'Read more';
        }, options);
      });
    }
    restorePhotoScroll() {
      if (this.photoPreviousOverflow !== undefined) {
        document.documentElement.style.overflow = this.photoPreviousOverflow;
        this.photoPreviousOverflow = undefined;
      }
    }
    disconnectedCallback() {
      if (this.lightbox?.open) this.lightbox.close();
      this.restorePhotoScroll();
      this.controller?.abort();
    }
  }
  customElements.define('sinclairs-reviews', SinclairsReviews);
})();

  } catch(e) { console.error(e); }
})();
})();
